module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/ZM-c7aa8c1f3d7c7ec7f6a13d4aacb6bfb1.png";